import * as React from 'react';
import AccessibleSVG from 'box-ui-elements/es/icons/accessible-svg';
import { bdlGray } from 'box-ui-elements/es/styles/variables';

type Props = {
  className?: string;
  color?: string;
  height?: number;
  title?: string;
  width?: number;
};

const LinkIcon = ({
  className = '',
  color = bdlGray,
  height = 16,
  title,
  width = 16,
}: Props) => (
  <AccessibleSVG
    className={className}
    height={height}
    title={title}
    viewBox="0 0 16 16"
    width={width}
  >
    <path
      d="M3.418 6.179a.503.503 0 1 1 .711.711L3.037 7.983a3.524 3.524 0 0 0 0 4.98 3.525 3.525 0 0 0 4.98 0l1.093-1.092a.503.503 0 0 1 .711.711L8.73 13.675a4.531 4.531 0 0 1-6.404 0 4.53 4.53 0 0 1 0-6.404zm7.262-.88l.068.057a.508.508 0 0 1 0 .712l-4.98 4.98a.509.509 0 0 1-.712 0 .508.508 0 0 1 0-.712l4.98-4.98a.51.51 0 0 1 .644-.057zm2.995-2.974a4.53 4.53 0 0 1 0 6.404L12.582 9.82a.503.503 0 0 1-.711-.711l1.092-1.093a3.524 3.524 0 0 0 0-4.98 3.525 3.525 0 0 0-4.98 0L6.89 4.129a.503.503 0 1 1-.711-.711L7.27 2.325a4.531 4.531 0 0 1 6.404 0z"
      fill={color}
      fillRule="evenodd"
    />
  </AccessibleSVG>
);

export default LinkIcon;
